<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayoutAlign.gt-xs="space-between center">
    <h1>Pagamentos do Concurso:</h1>
    <div>
      <app-export-button *ngIf="isSuperAdmin()" (export)="exportar()"></app-export-button>
    </div>
  </div>
  <h2>{{concursoTitulo}}</h2>

  <mat-form-field appearance="outline" display="inline-block">
    <mat-label>Filtrar</mat-label>
    <mat-select [(value)]="filtro" (valueChange)="selecionar()">
      <mat-option value="TODOS">Todos</mat-option>
      <mat-option value="PAGO">Pago</mat-option>
      <mat-option value="AGUARDANDO_PAGAMENTO">Aguardando Pagamento</mat-option>
    </mat-select>
  </mat-form-field>

  <app-search-input #searchInput></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let row">{{ row.nomeSocial || row.nome }}</td>
      </ng-container>
      <ng-container matColumnDef="cpf">
        <th mat-header-cell *matHeaderCellDef>CPF</th>
        <td mat-cell *matCellDef="let row">{{ row.cpf }}</td>
      </ng-container>
      <ng-container matColumnDef="protocolo">
        <th mat-header-cell *matHeaderCellDef>Protocolo</th>
        <td mat-cell *matCellDef="let row">{{ row.protocolo }}</td>
      </ng-container>
      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef>Valor</th>
        <td mat-cell *matCellDef="let row">{{ row.valor | number : '.2-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="actionComprovante">
        <th mat-header-cell *matHeaderCellDef class="w-140">Comprovante</th>
        <td mat-cell *matCellDef="let row">
          <div fxLayoutAlign="space-between center">
            <button
              mat-icon-button
              color="primary"
              (click)="verAnexo('inscricao/' + row.id + '/pagamento', row.depositoAnexo, row.concursoTitulo)"
              [disabled]="!row.depositoAnexo">
              <mat-icon>save_alt</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="pago">
        <th mat-header-cell *matHeaderCellDef>Pago</th>
        <td mat-cell *matCellDef="let row">
          <mat-select [(value)]="row.pago" [disabled]="row.concluida" panelClass="customMatSelectPanel">
            <mat-option [value]="true">Sim</mat-option>
            <mat-option [value]="false">Não</mat-option>
          </mat-select>
        </td>
      </ng-container>

      <ng-container matColumnDef="autor">
        <th mat-header-cell *matHeaderCellDef>Autor</th>
        <td mat-cell *matCellDef="let row">{{ row.autor }}</td>
      </ng-container>
      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let row">{{ row.data | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
      </ng-container>
      <ng-container matColumnDef="concluida">
        <th mat-header-cell *matHeaderCellDef>Concluída</th>
        <td mat-cell *matCellDef="let row">{{ row.concluida ? 'Sim' : 'Não' }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div fxLayoutAlign="space-between center" fxLayoutGap="5px">
            <button mat-icon-button color="primary" *ngIf="!row.concluida" title="Salvar" (click)="salvar(row)">
              <mat-icon>save</mat-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              *ngIf="row.data && !row.concluida"
              title="Concluir"
              (click)="concluir(row)">
              <mat-icon>check</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="11">
          <app-table-no-data [searchValue]="searchInput?.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator [length]="totalElements"></app-default-paginator>
  </div>
</div>
